import { useState } from "react";
import Screen from "../../components/Screen";
import TypeText from "../../components/TypeText";
import LandingValues from "../../components/LandingValues";
import { PrimaryBtn } from "../../components/Buttons";

interface NpPhoneProps {
  onNext: (phone: string) => void;
  /** 省略＝沒有上一步（傳單·未指定的起始畫面）→ 不顯示返回鍵。 */
  onBack?: () => void;
}

/** 傳單・無指定瓦斯行：先輸入手機號碼（後續發 OTP，並用門號尋找所屬瓦斯行）。 */
const NpPhone = ({ onNext, onBack }: NpPhoneProps) => {
  const [ph, setPh] = useState("09");
  const digits = ph.replace(/\D/g, "");
  const valid = /^09\d{8}$/.test(digits);

  return (
    <Screen
      title={<span className="inline-block text-[34px] leading-[1.15]"><TypeText text="Hi，歡迎使用" /></span>}
      subtitle="輸入手機號碼，我們為您找出配合的瓦斯行。"
      onBack={onBack}
      footer={<PrimaryBtn active={valid} onClick={() => onNext(digits)}>發送驗證碼</PrimaryBtn>}
    >
      <div className="text-[13px] text-[#475569] font-semibold mb-2">手機號碼</div>
      <div className="flex gap-2.5">
        <div className="flex items-center px-4 h-[54px] rounded-[14px] bg-[#F1F5F9] font-bold text-base text-[#333] shrink-0">+886</div>
        <input
          value={ph}
          onChange={(e) => setPh(e.target.value)}
          inputMode="numeric"
          placeholder="0912 345 678"
          className="flex-1 h-[54px] px-4 border-none rounded-[14px] bg-[#F1F5F9] text-[17px] outline-none box-border text-[#333]"
        />
      </div>
      {digits.length > 10 && (
        <div className="mt-2 text-[12px] text-[#EF4444] font-semibold">手機號碼為 10 碼，請確認是否多打了。</div>
      )}
      <div className="mt-2.5 text-[11.5px] text-[#64748B] leading-[1.6]">
        我們會傳送驗證碼確認本人。門號僅用於身分確認，不會對外顯示。
      </div>
      <LandingValues />
    </Screen>
  );
};

export default NpPhone;
